import React, { useEffect, useState } from 'react'
import { Sidebar, Heading, Text } from '../../components/ui'
import { PermissionGuard } from '../../components/PermissionGuard'
import { modulesService } from '../../services/modules'
import { PortalAtendimentoHelpdeskModulesTab } from './PortalAtendimentoHelpdeskModulesTab'
import { PortalAtendimentoPermissionsTab } from './PortalAtendimentoPermissionsTab'

const MODULE_NAME = 'configuracoes_portalatendimento'

const ConfiguracoesPortalAtendimento: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'modulos_helpdesk' | 'grupos_permissoes'>('modulos_helpdesk')
  const [moduleTitle, setModuleTitle] = useState('Configurações')
  const [moduleDescription, setModuleDescription] = useState('Portal de atendimento')

  useEffect(() => {
    const loadModuleInfo = async () => {
      try {
        const result = await modulesService.getByName(MODULE_NAME)
        if (result.success && result.data) {
          if (result.data.display_name) {
            setModuleTitle(result.data.display_name)
          }
          if (result.data.description) {
            setModuleDescription(result.data.description)
          }
        }
      } catch (error) {
        console.error('Erro ao buscar informações do módulo:', error)
      }
    }

    loadModuleInfo()
  }, [])

  const tabButtonClass = (active: boolean) =>
    `py-4 px-1 border-b-2 font-medium text-sm ${
      active
        ? 'border-blue-500 text-blue-600 dark:text-blue-400'
        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
    }`

  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
      <Sidebar />
      <main className="flex-1 flex flex-col overflow-x-hidden overflow-y-auto bg-gray-100 dark:bg-gray-900">
        <PermissionGuard
          moduleName="configuracoes_portalatendimento"
          permissionType="show"
          fallback={
            <div className="flex-1 flex items-center justify-center">
              <div className="text-center">
                <Text size="xl" className="text-gray-500 dark:text-gray-400 mb-2">
                  Acesso Negado
                </Text>
                <Text size="sm" color="muted">
                  Você não tem permissão para acessar esta página.
                </Text>
              </div>
            </div>
          }
        >
          <div className="py-6 px-4 sm:px-6 lg:px-8">
            <div className="mb-8">
              <Heading as="h1" size="3xl" className="text-gray-900 dark:text-white">
                {moduleTitle}
              </Heading>
              <Text size="sm" color="muted" className="mt-2">
                {moduleDescription}
              </Text>
            </div>

            <div className="mb-6 border-b border-gray-200 dark:border-gray-700">
              <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                <button
                  type="button"
                  className={tabButtonClass(activeTab === 'modulos_helpdesk')}
                  onClick={() => setActiveTab('modulos_helpdesk')}
                >
                  Módulos
                </button>
                <button
                  type="button"
                  className={tabButtonClass(activeTab === 'grupos_permissoes')}
                  onClick={() => setActiveTab('grupos_permissoes')}
                >
                  Grupos e Permissões
                </button>
              </nav>
            </div>

            {activeTab === 'modulos_helpdesk' && <PortalAtendimentoHelpdeskModulesTab />}

            {activeTab === 'grupos_permissoes' && <PortalAtendimentoPermissionsTab />}
          </div>
        </PermissionGuard>
      </main>
    </div>
  )
}

export default ConfiguracoesPortalAtendimento
